"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const PageRenderer_1 = __importDefault(require("../PageRenderer"));
const PageContexts_1 = require("../Contexts/PageContexts");
const FieldRender_1 = __importDefault(require("../wrappers/FieldRender"));
const RepeatableRender_1 = __importDefault(require("../wrappers/RepeatableRender"));
const ValidationOptimizer_1 = __importDefault(require("../wrappers/ValidationOptimizer"));
const GroupComponent = props => {
    const { controlDefinition, controlPath, values, value, displayMap, defaultDateTimeFormat, hidden } = props;
    const { controlMap, mainColumns } = (0, PageContexts_1.useControlProvider)();
    const renderFn = (0, react_1.useCallback)((props, repeatableProps) => {
        var _a;
        return react_1.default.createElement(controlMap.GroupWrapper, { functionDefinitions: props.functionDefinitions, controlDefinition: controlDefinition, isOriginal: repeatableProps.isOriginal, 
            //TODO: this doesn't seem correct
            itemCount: Object.keys(controlDefinition.template.elements).length, onAddClick: repeatableProps.onAddClick, onRemoveClick: repeatableProps.onRemoveClick, readOnly: !!props.readOnly, repeatable: repeatableProps.repeatable, repeatCount: repeatableProps.repeatCount, controlPath: controlPath, index: repeatableProps.index, value: value, values: values, displayMap: displayMap, mainColumns: mainColumns },
            react_1.default.createElement(PageRenderer_1.default, { childMode: true, template: controlDefinition.template, values: values, controlPathPrefix: repeatableProps.repeatable ? repeatableProps.controlPath : controlPath, defaultDateTimeFormat: defaultDateTimeFormat, hidden: ((_a = props.displayOptions) === null || _a === void 0 ? void 0 : _a.isVisible) === false || hidden }));
    }, [controlMap, controlDefinition, controlPath, value, values, displayMap, mainColumns, defaultDateTimeFormat, hidden]);
    const renderControl = (0, react_1.useCallback)((repeatableProps) => {
        return react_1.default.createElement(ValidationOptimizer_1.default, { key: controlPath, controlDefinition: controlDefinition, displayMap: displayMap, render: validationFn => {
                return (react_1.default.createElement(FieldRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, key: repeatableProps.key, render: props => renderFn(props, repeatableProps), value: repeatableProps.value, values: values, defaultDateTimeFormat: defaultDateTimeFormat, validationFn: validationFn }));
            } });
    }, [renderFn, controlDefinition, controlPath, values, defaultDateTimeFormat, displayMap]);
    return (react_1.default.createElement(RepeatableRender_1.default, { value: value, values: values, controlPath: controlPath, controlDefinition: controlDefinition, renderControl: renderControl, defaultValue: {} }));
};
exports.default = react_1.default.memo(GroupComponent);
